// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Table, Select, Button } from "antd";
import { Row, Col, PageHeader } from "antd";
import _ from "lodash/array";

import PropTypes from "prop-types";
import accounting from "accounting";

import moment from "moment";
import "moment/locale/ru";

import Can from "../../../rules/Can";

const Option = Select.Option;

class DataList extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  render() {
    const {
      loading,
      report,
      periodicity,
      fetchParams,
      onChangePeriodicity,
      onChangePaymentType,
      downloadReport,
      currentUser
    } = this.props;

    const reportGroupByPeriod = report.reduce(
      (
        r,
        v,
        i,
        a,
        k = moment(v.date)
          .startOf(periodicity)
        // .format("MM.DD.YY")
      ) => ((r[k] || (r[k] = [])).push(v), r),
      {}
    );
    console.log(reportGroupByPeriod);

    let reportData = [];
    Object.keys(reportGroupByPeriod).map(key => {
      let amountTotal = reportGroupByPeriod[key].reduce(
        (sum, record) => sum + Number(record.amount),
        0
      );

      reportData.push({
        id: `period-${key}`,
        period: null,
        date: key,
        company_name: null,
        amount: amountTotal,
        order_id: null,
        order_number: null,
        order_date: null,
        assignee: null,
        isGoup: true,
        isSubtotal: false
      });
      reportGroupByPeriod[key].map(item => {
        reportData.push({
          id: item.id,
          period: item.period,
          date: item.date,
          company_name: item.company_name,
          amount: item.amount,
          order_id: item.order_id,
          order_number: item.order_number,
          order_date: item.order_date,
          assignee: item.assignee,
          isGoup: false,
          isSubtotal: false
        });
      });
    });

    const columns = [
      {
        title: "Дата",
        dataIndex: "date",
        render: (date, record) => {
          if (record.isGoup) {
            return {
              children: (
                <b>
                  {periodicity == "month"
                    ? moment(date).format("MMMM YYYY")
                    : `${moment(date).quarter()} квартал`}
                </b>
              ),
              props: {
                colSpan: 2,
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: moment(date).format("L")
          };
        },
        align: "center",
        width: "15%"
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div style={{ textAlign: "center" }}>
              <span>Заказ</span>
              <br />
              <span>Счет</span>
            </div>
          </div>
        ),
        dataIndex: "order_number",
        render: (order_number, record) => {
          if (record.isGoup) {
            return {
              props: {
                colSpan: 0,
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span>
                  <Link to={`/orders/${record.order_id}/edit`}>
                    {order_number}
                  </Link>
                </span>
                <span style={{ fontSize: "12px", opacity: "0.7" }}>
                  {moment(record.order_date).format("L")}
                </span>
              </div>
            )
          };
        },
        align: "center",
        width: "15%"
      },
      {
        title: "Сумма",
        dataIndex: "amount",
        render: (amount, record) => {
          if (record.isGoup) {
            return {
              children: (
                <b>{accounting.formatNumber(Number(record.amount), 0, " ")}</b>
              ),
              props: {
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: accounting.formatNumber(Number(record.amount), 0, " ")
          };
        },
        align: "right",
        width: "15%"
      },
      {
        title: "Компания",
        dataIndex: "company_name",
        render: (company_name, record) => {
          if (record.isGoup) {
            return {
              props: {
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: record.company_name
          };
        },

        key: "company_name",
        width: "40%"
      },
      {
        title: "Ответственный",
        render: (assignee, record) => {
          if (record.isGoup) {
            return {
              props: {
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: record.assignee
          };
        },
        width: "15%"
      }
    ];

    let excelButton = (
      <Button
        key="3"
        type="dashed"
        icon="file-excel"
        onClick={downloadReport}
      >
        Загрузить
      </Button>
    );

    return (
      <PageHeader
        onBack={() => window.history.back()}
        title={`Поступления ДС (план)`}
        extra={[
          <Can
            role={currentUser.role}
            perform="reports:download"
            yes={() => (
              excelButton
            )}
            no={() =>
              null
            }
          />
        ]}
        footer={
          <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
            <Col span={24}>
              <Table
                bordered
                size={"middle"}
                loading={loading}
                pagination={false}
                columns={columns}
                dataSource={reportData}
                rowKey="id"
              />
            </Col>
          </Row>
        }
      >
        <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
          <Col xs={12} sm={12} md={12} lg={6} xl={6}>
            <Select
              style={{ width: "100%" }}
              value={periodicity}
              placeholder="Периодичность"
              optionFilterProp="children"
              filterOption={false}
              onChange={onChangePeriodicity}
            >
              <Option value={"month"}>месяц</Option>
              <Option value={"quarter"}>квартал</Option>
            </Select>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6} xl={6}>
            <Select
              style={{ width: "100%" }}
              value={fetchParams.paymentType}
              placeholder="Вид платежа"
              optionFilterProp="children"
              filterOption={false}
              onChange={onChangePaymentType}
            >
              <Option value={null}>все</Option>
              <Option value={"1"}>аванс (до начала работ)</Option>
              <Option value={"2"}>предоплата (до отгрузки)</Option>
              <Option value={"3"}>оплата (после отгрузки)</Option>
            </Select>
          </Col>
        </Row>
      </PageHeader>
    );
  }
}

DataList.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.object),
  meta: PropTypes.object,
  fetchParams: PropTypes.object
};

export default DataList;
